var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"error"},[_c('pre',[_vm._v(_vm._s(_vm.error))]),_c('font-awesome-icon',{staticClass:"close-icon",attrs:{"icon":"window-close","size":"lg"},on:{"click":function($event){return _vm.reset()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }